import { useFormikContext } from "formik";
import { useEffect, useMemo, useRef } from "react";
import _ from "lodash";
import useAutosaveKey from "./useAutosaveKey";

type AutosaveProps = {
  formKey: string;
  debounceMs?: number;
};

const Autosave: React.FC<AutosaveProps> = ({ formKey, debounceMs = 1000 }) => {
  const formikContext = useFormikContext();
  const isFirstRender = useRef(true);
  const autosaveKey = useAutosaveKey(formKey);

  const debouncedSave = useMemo(
    () =>
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      _.debounce((values: any) => {
        localStorage.setItem(autosaveKey, JSON.stringify(values));
      }, debounceMs),
    [debounceMs, autosaveKey]
  );

  useEffect(() => {
    if (!isFirstRender.current) {
      debouncedSave(formikContext.values);
    } else {
      isFirstRender.current = false;
    }
  }, [debouncedSave, formikContext.values]);

  return <></>;
};

export default Autosave;
